import axios from 'axios';
import localStorageService from 'app/services/localStorageService';
import { getEnv } from './envConfig'

const KEYCLOAK_URL = getEnv().KEYCLOAK_URL;
const REALM = getEnv().REALM;
const CLIENT_ID = getEnv().CLIENT_ID;

export async function login({ username, password }) {
  const params = new URLSearchParams();
  params.append('grant_type', 'password');
  params.append('client_id', CLIENT_ID);
  params.append('username', username);
  params.append('password', password);

  const response = await axios.post(
    `${KEYCLOAK_URL}/realms/${REALM}/protocol/openid-connect/token`,
    params
  );

  // Save both tokens
  localStorageService.setItem('access_token', response.data.access_token);
  localStorageService.setItem('refresh_token', response.data.refresh_token);

  return response.data;
}

export async function getAccessToken() {
  return await localStorageService.getItem('access_token');
}

export async function getRefreshToken() {
  return await localStorageService.getItem('refresh_token');
}

export async function refreshToken() {
  const refreshTokenValue = await getRefreshToken(); // ✅ FIX: await here
  if (!refreshTokenValue) throw new Error('No refresh token available');

  console.log("🔄 Refreshing with refresh token:", refreshTokenValue);

  const params = new URLSearchParams();
  params.append('grant_type', 'refresh_token');
  params.append('client_id', CLIENT_ID);
  params.append('refresh_token', refreshTokenValue);

  const response = await axios.post(
    `${KEYCLOAK_URL}/realms/${REALM}/protocol/openid-connect/token`,
    params
  );

  // ✅ Save new tokens
  localStorageService.setItem('access_token', response.data.access_token);
  localStorageService.setItem('refresh_token', response.data.refresh_token);

  return response.data.access_token;
}

export async function logout() {
  const refreshTokenValue = await getRefreshToken();
  if (!refreshTokenValue) return;

  const params = new URLSearchParams();
  params.append('client_id', CLIENT_ID);
  params.append('refresh_token', refreshTokenValue);

  await axios.post(
    `${KEYCLOAK_URL}/realms/${REALM}/protocol/openid-connect/logout`,
    params
  );

  localStorageService.removeItem('access_token');
  localStorageService.removeItem('refresh_token');
}
